<template>
  <div>
    <Item
      v-for="(item, index) in cartItems"
      :key="`${item.id}-${index}`"
      :item="item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from './Item';

export default {
  components: {
    Item,
  },
  computed: {
    ...mapGetters([
      'cartItems',
    ]),
  },
};
</script>
